import { render, staticRenderFns } from "./ZxdjForm.vue?vue&type=template&id=80f57338&scoped=true"
import script from "./ZxdjForm.vue?vue&type=script&lang=js"
export * from "./ZxdjForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f57338",
  null
  
)

export default component.exports